import { render, staticRenderFns } from "./ManualAdjustFrozenPointsDialog.vue?vue&type=template&id=4b61ef2c&scoped=true&lang=pug&"
import script from "./ManualAdjustFrozenPointsDialog.vue?vue&type=script&lang=ts&"
export * from "./ManualAdjustFrozenPointsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ManualAdjustFrozenPointsDialog.vue?vue&type=style&index=0&id=4b61ef2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61ef2c",
  null
  
)

export default component.exports